import bugsnag from 'services/bugsnag.js'
import authentication from 'services/authentication.js'
import Vue from 'vue'
import App from './App'
import PortalVue from 'portal-vue'
import global from '@/global.js'
import router from './router.js'
import '@/util/polyfill.js'
import store from '@/store/store.js'
import VueYoutube from 'vue-youtube'
import funnel from 'script/funnel.js'
import analytics from 'services/analytics.js'

import sv from '@/locale/sv.js'
import eng from '@/locale/eng.js'

import logScope from 'log-scope'
const log = logScope('main')

let app
let lang = 'eng'
const browserLanguage = navigator.language || navigator.userLanguage
if (typeof browserLanguage === 'string') {
  lang = browserLanguage.toLowerCase().indexOf('sv') === -1 ? 'eng' : 'sv'
  // lang = 'sv'
  log.debug(`Language: ${lang}`)
}

Vue.config.productionTip = false

window.k$ = {
  lang: lang,
  quantity: 1,
  couponCode: '',
  isLoggedIn: false
}

// 3rd party
analytics.init()
bugsnag.init(Vue)

// Locale
Vue.mixin({
  methods: {
    __ (str) {
      const translation = lang === 'sv' ? sv[str] : eng[str]

      if (!translation) {
        log.error(`No (${lang}) translation for: ${str}`)
        return str
      }

      return translation
    }
  }
})

// Global components
global(Vue)
Vue.use(PortalVue)
Vue.use(VueYoutube)

authentication.init()

authentication.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }

  // Log sales funnel
  funnel.init(router)
})
